import 'slick-carousel'
import Headroom from 'headroom.js';
export default {
  init() {
    // JavaScript to be fired on all pages

    let popup = $('.popup')
    let overlay = $('.overlay')
    $('.popup-open').click(function(e){
      e.preventDefault()
      let target = $(this).attr('data-target');
      popup.removeClass('active')
      $('.' + target).addClass('active')
      overlay.addClass('active')
      if($(window).width() <= 1366) {
        $('body, html').animate({
          scrollTop: 0,
        }, 'slow')
      }
    })

    $('.close-popup, .overlay, .popup-checkout-overlay').click(function () {
      popup.removeClass('active')
      overlay.removeClass('active')
      $('.popup-checkout-overlay').removeClass('active')
    })

    $(window).on('load', function () {
      $('.header .dropdown-men').detach().insertAfter('.header li.men-link a')
      $('.header .dropdown-junior').detach().insertAfter('.header li.boys-link a')

      let promoPopup = $('.promotion-popup')
      let cookiePopup = getCookie('promotionPopup')
      let mailchimpCookie = getCookie('mailchimpCookie')
      if(promoPopup.length && !cookiePopup) {
        setTimeout(() => {
          overlay.addClass('active')
          promoPopup.addClass('active')
          $('.promotion-popup .close, .overlay').click(function() {
            setCookie('promotionPopup', true, 1)
          })
        }, 1000)
      }
      let mailchimpPopup = $('.mailchimp-popup')
      let url = window.location.pathname
      if(mailchimpPopup && url !== '/' && mailchimpCookie != ''){
        setTimeout(() => {
          mailchimpPopup.addClass('active')
          overlay.addClass('active')
          $('.mailchimp-popup .close, .overlay').click(function() {
            setCookie('mailchimpCookie', true, 30)
          })
        }, 1000)
      }
    })

    $(document).ready(function () {

      $('.trigger-cookies a').click(function(e) {
        e.preventDefault();
        $('.change-settings-button').trigger('click')
      })

      if($(window).width() < 1024) {
        // $('.has-dropdown > a').click(function (e) {
        //   e.preventDefault()
        // })
        let dropdownEl = $('.has-dropdown')
        dropdownEl.click(function () {
          $('.dropdown').slideUp()
          dropdownEl.not($(this)).removeClass('active')
          $(this).toggleClass('active')
          $(this).find('.dropdown').stop().slideToggle()
        })
        // dropdownEl.find('a').click(function () {
        //   $('#menu_button').trigger('click')
        // })
      }

      if($(window).width() <= 768) {
        $('.section-bg:not(.banner-tabs)').each(function () {
          // let sectionBg = $(this).find('.banner-item img').attr('src')
          $(this).find('.banner-item').remove()
          // $(this).find('.banner-wrapper').css('background-image', 'url('+`${sectionBg}`+')')
        })
      }

      $('.promotions .promo-carousel').slick({
        items: 1,
        loop: true,
        nav: true,
        dots: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 3500,
      })
    
      $('a[href="#top"]').click( function () {
        $('html, body').animate({
          scrollTop: 0,
        }, 'slow')
        return false
      })
      
      $('.banner-carousel').each(function () {
        let slickCarousel =  $(this)
        let homeCarousel = $(this).hasClass('home-carousel')
        slickCarousel.slick({
          dots: true,
          arrows: true,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: homeCarousel ? '50px' :'100px',
          responsive: [
            {
              breakpoint: 480,
              settings: {
                centerMode: true,
                centerPadding: '0px',
                arrows: false,
              },
            },
          ],
        })
      })
      
      $('#menu_button').click(function () {
        $(this).toggleClass('active')
        $('#main_menu').stop().slideToggle()
      })

    })

    if(Headroom.cutsTheMustard) {
      const header = document.getElementById('header');
      const headroom = new Headroom(header);
      headroom.init();
    }

    $('.tabs-nav a').on('click', function (e) {
      e.preventDefault()
      $('.tab-active').removeClass('tab-active')
      $(this).parent().addClass('tab-active')
      $('.tab-content').hide()
      $('#'+$(this).attr('href')).fadeIn()
    });
    $('.tabs-nav li:first a').trigger('click')

    $('.accordion-info').hide()
    $('.accordion').each(function () {
      let accordion = $(this)
      let acordionTitle = accordion.find('.accordion-title')
      let acordionInfo = accordion.find('.accordion-info')
      acordionTitle.click(function () {
        $('.accordion').removeClass('active')
        $('.accordion-info').slideUp()
        acordionInfo.stop().slideToggle()
        $(this).parent().addClass('active')
      })
    })
    $('.accordion-title').first().trigger('click')

    $('.toggle-title').click(function () {
      $(this).toggleClass('active')
      $(this).parent('.toggle-text').toggleClass('active')
    })

    $(document).on('click', '.wp-notice .close', function() {
      $(this).parent().hide()
    })

    $('.table-nav a').on('click', function (e) {
      e.preventDefault()
      $('.table-active').removeClass('table-active')
      $(this).parent().addClass('table-active')
      $('.table-content').hide()
      $('#'+$(this).attr('href')).fadeIn()
    });
    $('.table-nav li:first a').trigger('click')

    $('.table-men-nav a').on('click', function (e) {
      e.preventDefault()
      $('.table-men-active').removeClass('table-men-active')
      $(this).parent().addClass('table-men-active')
      $('.table-content-men').hide()
      $('#'+$(this).attr('href')).fadeIn()
    });
    $('.table-men-nav li:first a').trigger('click')


    $('.products .product').each(function () {
      const mainImgSrc = $(this).find('.img-box').data('image')
      let productThumns = $(this).find('.thumb-box img')
      let mainImage = $(this).find('.img-box img')
      productThumns.each(function () {
        let hoveredThumb = $(this).data('big-thumb')
        $(this).mouseenter(function () {
          $(this).addClass('hovered')
          mainImage.attr('src', hoveredThumb)
        }).mouseleave(function () {
          $(this).removeClass('hovered')
        })
      })
      $(this).mouseleave(function () {
        mainImage.attr('src', mainImgSrc)
      })
    })

    if(getCookie('mailchimpPopup')){
      $('.mailchimp-popup, .overlay').removeClass('active')
    } else {
      setTimeout(() => {
        if($('.mailchimp-popup').length > 0) { $('.mailchimp-popup, .overlay').addClass('active') }
      }, 3000)
    }

    if(getCookie('promotionPopup')){
      $('.promotion-popup, .overlay').removeClass('active')
    } else {
      setTimeout(() => {
        if($('promotion-popup').length > 0) { $('.promotion-popup, .overlay').addClass('active') }
      }, 3000)
    }
  
    $('.mailchimp-popup .close-popup').click(function(){
      $('.mailchimp-popup, .overlay').removeClass('active')
      setCookie('mailchimpPopup', true, 7)
    })
  
    $('.promotion-popup .close-popup').click(function(){
      $('.promotion-popup, .overlay').removeClass('active')
      setCookie('promotionPopup', true, 7)
    })
  
    function getCookie(cname) {
      var name = cname + '=';
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    }
  
    function setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      var expires = 'expires=+ d.toUTCString()'
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js